(function () {
  document.querySelectorAll('.main-blog').forEach(function (section) {
    const grid = section.querySelector('.blog-articles');
    const btn = section.querySelector('.blog-load-more-btn');

    if (!grid || !btn) return;

    const defaultText = btn.textContent.trim();

    btn.addEventListener('click', loadMore);

    async function loadMore() {
      const nextUrl = grid.dataset.nextUrl;
      if (!nextUrl) {
        btn.closest('.blog-load-more-wrapper').remove();
        return;
      }

      btn.disabled = true;
      btn.textContent = 'Loading...';

      try {
        const response = await fetch(nextUrl);
        if (!response.ok) throw new Error('Fetch failed');

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newCards = doc.querySelectorAll('.blog-articles .blog-articles__article');

        newCards.forEach(function (card) {
          // Strip Dawn scroll animation classes — appended cards won't re-register
          // with the IntersectionObserver set up on DOMContentLoaded
          card.classList.remove('scroll-trigger', 'animate--slide-in');
          card.removeAttribute('data-cascade');
          card.style.removeProperty('--animation-order');

          grid.appendChild(card);
        });

        const fetchedGrid = doc.querySelector('.blog-articles');
        const newNextUrl = fetchedGrid ? (fetchedGrid.dataset.nextUrl || '') : '';
        grid.dataset.nextUrl = newNextUrl;

        if (!newNextUrl) {
          btn.closest('.blog-load-more-wrapper').remove();
        } else {
          btn.disabled = false;
          btn.textContent = defaultText;
        }

      } catch (err) {
        console.error('Blog load more error:', err);
        btn.disabled = false;
        btn.textContent = defaultText;
      }
    }
  });
})();
